import React, { Fragment } from 'react'
import ReactTooltip from 'react-tooltip'
import PropTypes from 'prop-types'
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'

const IconTooltip = ( { message, icon, color, onClick } ) => (
  <Fragment >
    <ReactTooltip />
    <span data-tip={message} className={`ml-1 ${color}`}>
      <FontAwesomeIcon onClick={() => onClick && onClick()} style={{ cursor: 'pointer' }} icon={icon} />
    </span>
  </Fragment>
)

IconTooltip.propTypes = {
  message: PropTypes.string,
  color: PropTypes.string,
  icon: PropTypes.string.isRequired,
  onClick: PropTypes.func,
}

IconTooltip.defaultProps = {
  message: '',
  color: 'danger',
}

export default IconTooltip
